import React from 'react';
import { useField } from 'informed';

import { ParamFormFieldContainer } from './StyledComponent';

export interface ParamsFormFieldTypes {
  field: string;
  isHidden: boolean;
}

export const ParamsFormField = (props: ParamsFormFieldTypes) => {
  const { field, isHidden } = props;
  const { render } = useField({
    field,
  });
  return render(<ParamFormFieldContainer key={field} isHidden={isHidden} />);
};
